module.exports = "/images/_/_/_/_/frontend/resources/js/src/assets/images/logo/logo.png";